// `code === -1` is the Executer's marker for no response at all (network, CORS, DNS, timeout).
export const describeFailure = res => {
  if (res.code === -1) return 'Could not reach the server. Check your connection and retry.';
  return res.data?.message ?? 'The server returned an unexpected error.';
};
